export enum DemographicsDataKey {
  Male = 'demographicsMale',
  Female = 'demographicsFemale',
  Age16_24 = 'demographicsAge16_24',
  Age25_44 = 'demographicsAge25_44',
  Age45_plus = 'demographicsAge45',
}
